import script from "./EmailActivity.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailActivity.vue?vue&type=script&setup=true&lang=js"

import "./EmailActivity.vue?vue&type=style&index=0&id=72103f47&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72103f47"]])

export default __exports__